import type { Contributor } from "~/models/Content/schemas"
import { formatList } from "~/utilities/format"

const DEFAULT_PUBLISHER = "Universitetsforlaget, Aschehougs akademiske forlag."

export const formatAuthors = (contributors: ProductContributorWithDetails[] | undefined) => {
  if (!contributors?.length) {
    return DEFAULT_PUBLISHER
  }

  const formattedNames = contributors.map(c => formatName(c.details))

  if (formattedNames.length === 1) {
    return formattedNames[0]
  }

  return formatList(formattedNames).replace(/ og /, ", & ")
}

const formatName = (details: Contributor) => {
  const initials = details.firstname
    .split(" ")
    .map(name => `${name[0]}.`)
    .join(" ")

  return `${details.lastname}, ${initials}`
}
